const moment = require('moment-timezone')

export function getFormatDateTime(timestamp, timezone) {
	if (!timestamp) return ''
	
	// Convert timestamp to local timezone
	const localDate = moment(timestamp).local()
	
	// Format date according to locale
	return localDate.format('dddd, MMM D, YYYY')
}

export function getFormatTimedata(startTime, endTime, timezone) {
	if (!startTime || !endTime) return ''

	// Convert timestamps to local timezone 
	const startLocal = moment(startTime).local()
	const endLocal = moment(endTime).local()

	// Format times
	const formattedStartTime = startLocal.format('h:mmA')
	const formattedEndTime = endLocal.format('h:mmA')

	return `${formattedStartTime}-${formattedEndTime}`
}

export function getFormatTime(timestamp, timezone) {
	if (timestamp) {
		const timezoneConvert = moment.tz(timestamp, timezone)
		const formattedTime = timezoneConvert.format('hh:mm a')
		return formattedTime
	}
}

export const getLocalTimeZone = () => {
	const offset = moment().utcOffset() / 60
	const sign = offset >= 0 ? '+' : '-'
	return `GMT${sign}${Math.abs(offset)}`
}

export const formatDate = (dateString) => {
	const date = new Date(dateString)
	return date.toLocaleDateString('en-US', {
		weekday: 'long',
		month: 'short', 
		day: 'numeric',
		year: 'numeric'
	})
}

export const formatTime = (dateString) => {
	const date = new Date(dateString)
	return date.toLocaleTimeString('en-US', {
		hour: '2-digit',
		minute: '2-digit',
		hour12: true
	})
}
